// Find Your Fit Carousel Functionality
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.findfit');
  if (!sections.length) return;

  // Function to calculate sticky header height
  const getStickyHeaderHeight = () => {
    const stickyHeader = document.querySelector('.section-header-top');
    if (!stickyHeader) return 0;
    
    // Get the actual visible height of the sticky header
    const rect = stickyHeader.getBoundingClientRect();
    return Math.max(0, rect.height);
  };

  // Function to handle smooth scroll with header offset
  const scrollToElementWithOffset = (targetId) => {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;
    
    const headerHeight = getStickyHeaderHeight();
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 10; // Extra 10px padding
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  // Add click handlers for anchor links
  sections.forEach(section => {
    const anchorLinks = section.querySelectorAll('.findfit__anchor-link');
    anchorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1); // Remove the # from href
        scrollToElementWithOffset(targetId);
      });
    });
  });

  // Handle direct navigation to anchor links (#men / #women / #findfit-…)
  const handleHashOnLoad = () => {
    const h = window.location.hash.slice(1);
    if (!h) return;

    const targetEl = (h === 'men' || h === 'women')
      ? document.querySelector(`.findfit__group[data-group="${h}"]`)
      : document.getElementById(h);

    if (!targetEl) return;

      setTimeout(() => {
      const headerHeight = getStickyHeaderHeight();
      const y = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }, 100);
  };

  // Check for hash on initial load
  handleHashOnLoad();

  // Handle hash changes (back/forward browser navigation)
  window.addEventListener('hashchange', handleHashOnLoad);

  sections.forEach(root => {
    const panels = root.querySelectorAll('[role="region"]');

    // Initialize card carousels with active state tracking
    const initCarousel = (container) => {
      const rail = container.querySelector('.findfit__rail');
      const contentRail = container.querySelector('.findfit__rail--content');
      const prevBtn = container.querySelector('.js-carousel-prev');
      const nextBtn = container.querySelector('.js-carousel-next');
      
      if (!rail || !prevBtn || !nextBtn) return;

      const cards = rail.querySelectorAll('.findfit-card');
      const contentCards = contentRail ? contentRail.querySelectorAll('.findfit-card') : [];
      let currentIndex = 0;
      let observer;

      const getCardWidth = () => {
        if (window.innerWidth <= 749) {
          // Mobile: Calculate full card width including gap
          const viewportWidth = window.innerWidth;
          const padding = 32; // 16px on each side
          const gap = 16;
          return (viewportWidth - padding - gap) * (250 / 321) + gap; // Full card width + gap
        }
        return 250 + 16; // Desktop fallback
      };

      const setActiveCard = (index) => {
        // Remove active class from all cards
        cards.forEach(card => card.classList.remove('is-active'));
        contentCards.forEach(card => card.classList.remove('is-active'));
        
        // Add active class to current card
        if (cards[index]) {
          cards[index].classList.add('is-active');
        }
        
        // Find and activate corresponding content card
        if (contentCards[index]) {
          contentCards[index].classList.add('is-active');
        }
        
        currentIndex = index;
      };

      const updateButtons = () => {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= cards.length - 1;
      };

      const scrollToCard = (index, forceScroll = false) => {
        // Ensure index is within bounds
        const maxIndex = cards.length - 1;
        const targetIndex = Math.max(0, Math.min(index, maxIndex));
        
        const cardWidth = getCardWidth();
        const scrollLeft = targetIndex * cardWidth;
        
        // Force scroll to exact position
        if (forceScroll || Math.abs(rail.scrollLeft - scrollLeft) > 10) {
          rail.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
        
        setActiveCard(targetIndex);
        updateButtons();
      };

      const getCurrentCardIndex = () => {
        const cardWidth = getCardWidth();
        const scrollLeft = rail.scrollLeft;
        return Math.round(scrollLeft / cardWidth);
      };

      // Initialize intersection observer for mobile
      const initIntersectionObserver = () => {
        if (observer) observer.disconnect();
        
        if (window.innerWidth <= 749) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.9) {
                const cardIndex = Array.from(cards).indexOf(entry.target);
                if (cardIndex !== -1 && cardIndex !== currentIndex) {
                  setActiveCard(cardIndex);
                  updateButtons();
                }
              }
            });
          }, {
            root: rail,
            threshold: [0.9],
            rootMargin: '0px'
          });

          cards.forEach(card => observer.observe(card));
        }
      };

      prevBtn.addEventListener('click', () => {
        // Get current position and move back exactly one card
        const actualIndex = getCurrentCardIndex();
        const targetIndex = Math.max(0, actualIndex - 1);
        scrollToCard(targetIndex, true);
      });

      nextBtn.addEventListener('click', () => {
        // Get current position and move forward exactly one card
        const actualIndex = getCurrentCardIndex();
        const targetIndex = Math.min(cards.length - 1, actualIndex + 1);
        scrollToCard(targetIndex, true);
      });

      // Handle manual scroll/swipe
      let scrollTimeout;
      rail.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const actualIndex = getCurrentCardIndex();
          if (actualIndex !== currentIndex) {
            // Force snap to card position
            scrollToCard(actualIndex, false);
          }
        }, 150);
      });

      // Handle touch/swipe end - ensure we snap to a card
      let isScrolling = false;
      rail.addEventListener('touchstart', () => {
        isScrolling = true;
      });

      rail.addEventListener('touchend', () => {
        if (isScrolling) {
          setTimeout(() => {
            const actualIndex = getCurrentCardIndex();
            scrollToCard(actualIndex, true);
            isScrolling = false;
          }, 100);
        }
      });

      // Initialize
      initIntersectionObserver();
      scrollToCard(0, true);

      // Update on window resize
      window.addEventListener('resize', () => {
        initIntersectionObserver();
        scrollToCard(currentIndex, true);
      });
    };

    // Initialize carousels for both sections
    panels.forEach(panel => {
      initCarousel(panel);
    });
  });
});
